// La pantalla de la pared (desde el 03-11, el primer widget de la oficina): las ventas netas del día, su comparación con
// ayer y una barra por hora UTC (hoy en oro; las horas aún sin cerrar, en gris). Pulsarla abre la Sala de Control.
import { WIDGET } from '../ui';
import { t } from '../../../i18n';
import { cn } from '../../../lib/utils';
import { delta, horaUtc, numero, SIN_VALOR } from './formato';
import type { PulsoSala } from './tipos';

export function PantallaPared({ pulso, alAbrir }: { pulso: PulsoSala | null; alAbrir: () => void }) {
  const v = pulso?.ventas;
  const d = v ? delta(v.hoy, v.ayer, false) : null;
  const aviso = pulso?.estado === 'retraso' || (pulso?.avisos.length ?? 0) > 0;
  return (
    <button
      type="button"
      onClick={alAbrir}
      aria-label={t('salaControl.abrir')}
      className={WIDGET}
    >
      <span className="flex items-center gap-1.5 text-o-mini text-oficina-texto2">
        <span className={cn('h-2 w-2 rounded-full', !pulso ? 'bg-oficina-esperando' : aviso ? 'bg-oficina-bloqueado' : 'bg-oficina-trabajando')} />
        {t('salaControl.pantalla.ventas', { hora: pulso?.hora_utc != null ? horaUtc(pulso.hora_utc, pulso.generado_at ? new Date(pulso.generado_at) : new Date()) : SIN_VALOR })}
      </span>
      <span className="mt-1 block text-o-titulo2 font-bold leading-tight text-oficina-texto">{v ? `${numero(v.hoy / 1000, 1)} k$` : SIN_VALOR}</span>
      {d && d.direccion !== 'igual' ? (
        <span className={cn('block text-o-mini', d.tono === 'bueno' ? 'text-oficina-trabajando' : 'text-oficina-error')}>
          {t('salaControl.pantalla.vsAyer', { delta: `${d.direccion === 'sube' ? '↑' : '↓'} ${d.texto}` })}
        </span>
      ) : null}
      <BarrasHora hoy={pulso?.porHora?.ventas?.hoy ?? null} ayer={pulso?.porHora?.ventas?.ayer ?? null} />
    </button>
  );
}

/** Una barra por hora UTC: hoy en oro (si la hora ya cerró), y detrás, apagada, la de ayer a esa hora. Decorativa: las
 *  cifras exactas están en la Sala (el widget se nombra entero con su aria-label). */
function BarrasHora({ hoy, ayer }: { hoy: Array<number | null> | null; ayer: Array<number | null> | null }) {
  if (!hoy?.length) return null;
  const max = Math.max(1, ...hoy.map((v) => v ?? 0), ...(ayer ?? []).map((v) => v ?? 0));
  return (
    <span className="mt-auto flex h-10 items-end gap-0.5 pt-2" aria-hidden data-testid="barras-hora">
      {hoy.map((v, i) => (
        <span key={i} className="relative flex h-full flex-1 items-end">
          {ayer?.[i] != null ? <span className="absolute inset-x-0 bottom-0 rounded-t-sm bg-oficina-pulsado" style={{ height: `${(ayer[i]! / max) * 100}%` }} /> : null}
          {v != null ? <span className="relative w-full rounded-t-sm bg-oficina-acento" style={{ height: `${Math.max(4, (v / max) * 100)}%` }} /> : null}
        </span>
      ))}
    </span>
  );
}
